export const GET_SALTUSOWNERS_REQUESTED = 'GET_SALTUSOWNERS_REQUESTED';
export const GET_SALTUSOWNERS_COMPLETED = 'GET_SALTUSOWNERS_COMPLETED';
export const GET_SALTUSOWNERS_FAILED = 'GET_SALTUSOWNERS_FAILED';
export const RESET_SALTUSOWNERS_REQUESTED = 'RESET_SALTUSOWNERS_REQUESTED';
export const RESET_SALTUSOWNERS_COMPLETED = 'RESET_SALTUSOWNERS_COMPLETED';
